/** Runtime encounters may be page-owned. The tg prefix is never a persisted row identity. */
export function isEncounterIdentity(value: unknown): value is string {
    return typeof value === 'string' && /^(?:tg-)?[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(value);
}
